// Tokens visuais do celular (rota /c), extraídos 1:1 de mockups/1c-celular-gravando.html
// e mockups/1e-celular-codigo.html. Tema ESCURO — separado de styles/tokens.ts (editor,
// tema claro) de propósito: são dois contextos visuais distintos. NÃO ajustar valores
// sem revalidar os mockups.

import type { CSSProperties } from 'react';

export const corC = {
  fundoExterno: '#1a1a1a', // body atrás do "aparelho"
  fundo: '#0f1315', // tela
  texto: '#e8ecef',
  muted: '#8b9aa4',

  azul: '#5980a6', // botão primário
  contraste: '#0f1315', // texto sobre o azul
  ondaBase: '#5f8cba', // barras da onda
  ondaRecente: '#7ba3cb', // barras recentes (borda da onda)
  vermelho: '#c0392b', // ponto "GRAVANDO"

  borda: 'rgba(232,236,239,.28)', // borda de botão secundário
  divisor: 'rgba(232,236,239,.18)', // linha ao lado do rótulo
  divisorFraco: 'rgba(232,236,239,.12)', // borda-topo dos rodapés

  blueprint: 'rgba(123,163,203,.4)', // moldura do código
  blueprintCorner: 'rgba(123,163,203,.7)',
  separador: 'rgba(232,236,239,.35)', // traço entre os dois grupos do código

  // Aviso de interrupção (auto-pausa): âmbar legível sobre fundo escuro. Não vem
  // do mockup — o mockup não tem estado de interrupção.
  avisoBorda: '#e8b04b',
  avisoBg: 'rgba(232,176,75,.12)',
  avisoTexto: '#f0c46b',
} as const;

export const fonteC = {
  corpo: '"Barlow", system-ui, sans-serif',
  condensada: '"Barlow Condensed", system-ui, sans-serif',
  mono: "ui-monospace, 'Courier New', monospace",
} as const;

// Botões — espelham os dois estilos dos mockups (primário azul / contorno).
export const btnPrimarioC: CSSProperties = {
  border: 0,
  background: corC.azul,
  color: corC.contraste,
  fontFamily: fonteC.condensada,
  fontWeight: 600,
  letterSpacing: '.1em',
  cursor: 'pointer',
};

export const btnSecundarioC: CSSProperties = {
  background: 'transparent',
  border: `1px solid ${corC.borda}`,
  color: corC.texto,
  fontFamily: fonteC.condensada,
  fontWeight: 600,
  letterSpacing: '.1em',
  cursor: 'pointer',
};
